import React from 'react';
import { Box, Button, TextField } from '@mui/material';
import { Autosuggest, TextInput } from 'components';
import { COUNTRIES } from 'lib/constants/countries';

const ClubForm = ({ club, isEditing, handleChange }) => (
	<Box>
		<TextField
			label="Club Name"
			value={club.name}
			onChange={(e) => handleChange('name', e.target.value)}
			fullWidth
		/>
		<TextField
			label="Location"
			value={club.location}
			onChange={(e) => handleChange('location', e.target.value)}
			fullWidth
		/>
		<TextInput
			value={club.contact_email}
			label="Contact email"
			name="contact_email"
			placeholder="Contact email"
			handleChange={handleChange}
		/>
		<TextInput
			value={club.contact_phone}
			label="Contact phone"
			name="contact_phone"
			placeholder="Contact phone"
			handleChange={handleChange}
		/>
		<TextInput
			value={club.city}
			label="City"
			name="city"
			placeholder="City"
			handleChange={handleChange}
		/>
		<Autosuggest
			options={COUNTRIES}
			value={club.country}
			label="Country"
			name="country"
			placeholder="Country"
			handleChange={handleChange}
		/>
		<TextInput
			multiline
			rows={3}
			value={club.main_ground}
			label="Main ground address"
			name="main_ground"
			placeholder="Main ground address"
			handleChange={handleChange}
		/>
		<TextInput
			multiline
			rows={3}
			value={club.training_ground}
			label="Training ground"
			name="training_ground"
			placeholder="Training ground address"
			handleChange={handleChange}
		/>
		<TextInput
			value={club.level}
			label="Level"
			name="level"
			placeholder="Level"
			handleChange={handleChange}
		/>
		<TextInput
			value={club.website}
			label="Website"
			name="website"
			placeholder="Website"
			handleChange={handleChange}
		/>
		<TextInput
			type={'number'}
			value={club.lat}
			label="Latitude"
			name="lat"
			placeholder="Latitude"
			handleChange={handleChange}
		/>
		<TextInput
			type={'number'}
			value={club.lng}
			label="Longitude"
			name="lng"
			placeholder="Longitude"
			handleChange={handleChange}
		/>
		<Button
			variant="contained"
			color="primary"
			onClick={() => {
				/* handle save */
			}}
		>
			Save
		</Button>
	</Box>
);

export default ClubForm;
